// CSS heredado del plugin WP oksigenia-access v16.9.
// Separado en dos bloques:
//   · PANEL_CSS — estilos del panel + botón trigger. Van al Shadow DOM
//     del custom element, no contaminan el host site.
//   · EFFECT_CSS — estilos de las clases que afectan al `body`/`html`
//     (zoom, contraste, dyslexia, etc.). Inyectados en `document.head`
//     porque tienen que cruzar el boundary del Shadow DOM.

export const PANEL_CSS = `
:host {
  --oks-btn-size: 55px;
  --oks-bg: #000;
  --oks-icon: #fff;
  --oks-h-bg: #fff;
  --oks-h-icon: #000;
  --oks-z: 9999999;
}
.oks-access-wrapper {
  position: fixed;
  z-index: var(--oks-z);
  line-height: 1;
  transition: bottom 0.3s;
}
.oks-access-btn {
  width: var(--oks-btn-size);
  height: var(--oks-btn-size);
  border-radius: 50%;
  background: var(--oks-bg);
  color: var(--oks-icon);
  border: 2px solid #fff;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  padding: 0;
}
.oks-access-btn:hover {
  background: var(--oks-h-bg);
  color: var(--oks-h-icon);
  transform: scale(1.1);
}
.oks-access-btn svg {
  fill: currentColor;
  display: block;
  margin: 0 auto;
  width: 60%;
  height: 60%;
}
/* Porthole preset: a brushed-metal ring framing the standard glyph. The glyph
   itself is untouched (discoverability), only the button gets the frame.
   Hosts wanting a bespoke frame can target ::part(trigger) from light DOM. */
.oks-access-btn[data-trigger-icon="porthole"] {
  box-shadow: 0 0 0 4px #b0bec5, 0 0 0 7px #546e7a, 0 6px 18px rgba(0,0,0,0.3);
}
.oks-active-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: #25D366;
  border-radius: 50%;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  pointer-events: none;
}
.oks-active-badge svg { width: 12px; height: 12px; }
.oks-access-wrapper.has-active .oks-active-badge { opacity: 1; }
/* Folded: the edge and the tab's shape come from positionCss. */
.oks-access-wrapper.is-folded .oks-access-btn,
.oks-access-wrapper.is-folded .oks-access-btn[data-trigger-icon="porthole"] {
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
}
.oks-access-wrapper.is-folded .oks-access-btn:hover { transform: none; }
.oks-access-wrapper.is-folded .oks-access-btn svg { width: 18px; height: 18px; }
.oks-access-wrapper.is-folded .oks-active-badge { display: none; }

.oks-access-panel {
  position: fixed;
  width: 340px;
  max-height: 90vh;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  z-index: var(--oks-z);
  display: flex;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  transition: 0.2s;
  border: 1px solid rgba(0,0,0,0.1);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  color: #333;
}
.oks-access-panel.is-open { opacity: 1; pointer-events: all; }
.oks-access-header {
  flex: 0 0 auto;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.oks-access-header h3 { margin: 0; font-size: 18px; color: #000; }
.oks-access-close {
  background: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  padding: 0;
}
.oks-access-close:hover { background: #e0e0e0; border-color: #ccc; }
.oks-access-close svg { width: 24px; height: 24px; stroke-width: 2.5px; }
/* flex:1 1 auto + min-height:0 lets the content scroll inside the 90vh panel.
   Without min-height:0 a flex child won't shrink below its content, so the
   header (×) and footer (Reset) get pushed off-screen on short viewports or at
   high zoom — the panel becomes impossible to close. */
.oks-access-content { flex: 1 1 auto; min-height: 0; padding: 0 20px 20px; overflow-y: auto; }
.oks-access-title {
  margin: 10px 0 5px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  color: #595959;
}
/* Screen-reader-only: keeps the category headings in the accessibility tree
   (flat scoped layout) while taking them out of the grid flow so they don't
   force a visual row break or occupy a cell. */
.oks-sr-only {
  position: absolute !important;
  width: 1px; height: 1px;
  margin: 0; padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
.oks-access-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 8px; }
/* Two per row, icon beside the label: four across left about 75px each, too narrow for whole words
   (Sin distracciones, Sehschwäche) without abbreviating or splitting them. */
.oks-access-presets { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; }
.oks-preset {
  background: #f0f4f8;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font: inherit;
  color: #333;
  min-width: 0;
  transition: 0.15s;
}
.oks-preset:hover { background: #000; color: #fff; }
.oks-preset:focus-visible { outline: 2px solid #000; outline-offset: 2px; }
/* Click feedback: a 250 ms flip + slight squeeze. Pure transient — the
   button does not carry persistent active state because a preset is a
   trigger, not a mode. */
.oks-preset.is-flashing {
  background: #000;
  color: #fff;
  transform: scale(0.96);
}
.oks-preset .oks-icon { font-size: 22px; flex: 0 0 auto; }
.oks-preset .oks-icon svg { width: 20px; height: 20px; }
.oks-preset .oks-label {
  font-size: 10px; font-weight: 700; text-transform: uppercase;
  text-align: left; line-height: 1.15;
  overflow-wrap: break-word; hyphens: auto;
  /* Two lines' room, so a short label and one that wraps keep the same height. */
  min-height: 2.3em;
  display: flex; align-items: center;
}
.oks-access-opt {
  background: #f9f9f9;
  border: 2px solid #eee;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 0;
  min-height: 70px;
  color: #333;
  transition: 0.2s;
  font: inherit;
}
.oks-access-opt.full-width { grid-column: span 2; }
.oks-access-opt.is-active {
  border-color: #000;
  background: #fff;
  box-shadow: 0 0 0 1px #000;
}
.oks-access-opt:hover { background: #000; color: #fff; border-color: #000; }
.oks-icon { font-size: 28px; margin-bottom: 3px; display: block; line-height: 1; }
.oks-icon svg { width: 24px; height: 24px; fill: currentColor; }
.oks-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.2;
  overflow-wrap: break-word;
  hyphens: auto;
}
.oks-levels { display: flex; gap: 3px; height: 5px; width: 50%; margin-top: 5px; }
.oks-levels span { flex: 1; background: #ddd; border-radius: 3px; }
.oks-access-opt[data-level="1"] .oks-levels span:nth-child(1),
.oks-access-opt[data-level="2"] .oks-levels span:nth-child(-n+2),
.oks-access-opt[data-level="3"] .oks-levels span:nth-child(-n+3),
.oks-access-opt[data-level="4"] .oks-levels span:nth-child(-n+4) { background: #000; }
.oks-access-opt:hover .oks-levels span { background: #555; }
.oks-access-footer {
  flex: 0 0 auto;
  padding: 12px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}
.oks-access-actions { display: flex; gap: 8px; }
.oks-access-reset {
  flex: 1 1 0;
  padding: 8px;
  border: 2px solid #000;
  color: #000;
  background: transparent;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  font-size: 12px;
}
.oks-access-reset:hover { background: #000; color: #fff; }
.oks-access-fold {
  flex: 1 1 0;
  padding: 8px;
  border: 1px solid #000;
  color: #000;
  background: #f2f2f2;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  font-size: 12px;
}
.oks-access-fold:hover { background: #000; color: #fff; }
.oks-access-branding { margin-top: 12px; font-size: 12px; color: #000; font-weight: 700; }
.oks-access-branding a { color: #000; text-decoration: none; border-bottom: 1px dotted #000; }

@media (prefers-reduced-motion: reduce) {
  .oks-access-btn, .oks-access-panel, .oks-access-close,
  .oks-preset, .oks-access-opt, .oks-access-wrapper { transition: none; }
  .oks-access-btn:hover { transform: scale(1); }
  .oks-preset.is-flashing { transform: none; }
}
@media (max-width: 768px) {
  .oks-access-panel {
    width: 100%; height: 100%; max-height: 100%;
    top: 0; left: 0; right: 0; bottom: 0;
    border-radius: 0;
  }
  .oks-access-opt { min-height: 72px; padding: 10px 8px; }
  .oks-icon svg { width: 26px; height: 26px; }
  .oks-label { font-size: 12px; line-height: 1.25; }
  .oks-access-grid { gap: 8px; }
  .oks-access-content { padding: 0 14px 20px; }
  .oks-access-title { font-size: 11px; margin: 10px 0 4px; }
  /* Cursor grande no aplica en táctil: oculto y dejo el último botón
     de la sección ocupando 2 columnas para no romper la grilla par. */
  .oks-access-opt[data-class="oks-big-cursor"] { display: none; }
  .oks-access-opt[data-class="oks-a11y-focus"] { grid-column: span 2; }
  .oks-access-reset, .oks-access-fold { padding: 14px; font-size: 14px; }
}
`;

// Icon fonts (Font Awesome in Moodle, Dashicons in WordPress, Material,
// Bootstrap Icons...) draw their glyphs from their own font-family. Forcing a
// reading font on them turns every icon into an empty box, so the font
// overrides skip them.
const NOT_ICON_FONT = ':not(.fa, [class*="fa-"], .icon, [class^="icon-"], [class*=" icon-"], .dashicons, [class*="dashicons-"], .material-icons, [class^="material-symbols"], .glyphicon, [class^="bi-"], [class*=" bi-"])';

// Estilos globales aplicados al document. NO van al Shadow DOM porque
// tienen que afectar al body del host site.
export const EFFECT_CSS = `
html.oks-colorblind-1 { filter: url('#oks-filter-protanopia'); }
html.oks-colorblind-2 { filter: url('#oks-filter-deuteranopia'); }
html.oks-colorblind-3 { filter: url('#oks-filter-tritanopia'); }

/* Text-size levels.
   Applied to <html> via :has(), not to <body>. rem is anchored to the root
   element, so a site whose CSS sizes things in rem (most modern Astro / Tailwind
   builds) needs the root font-size to change for the scale to take effect.
   A previous version applied this to body with %, which only moved descendants
   that inherited font-size from body — anything sized in rem stayed locked to
   the 16px default of <html>. An even earlier version used the universal
   selector with em and compounded the factor at every nesting level.
   :has(body.oks-zoom-N) is the right anchor: one change at the root, rem
   descendants scale exactly once. Hard-coded px is intentionally left alone;
   browser zoom covers that case. */
html:has(body.oks-zoom-1) { font-size: 110% !important; }
html:has(body.oks-zoom-2) { font-size: 120% !important; }
html:has(body.oks-zoom-3) { font-size: 135% !important; }
html:has(body.oks-zoom-4) { font-size: 150% !important; }

body.oks-lh-1 * { line-height: 1.6 !important; }
body.oks-lh-2 * { line-height: 1.9 !important; }
body.oks-lh-3 * { line-height: 2.2 !important; }

body.oks-a11y-font { font-family: Arial, sans-serif !important; }

body.oks-dyslexia *${NOT_ICON_FONT} {
  font-family: 'Comic Sans MS', 'Verdana', sans-serif !important;
  letter-spacing: 0.05em !important;
  word-spacing: 0.1em !important;
  line-height: 1.6 !important;
}

body.oks-a11y-hide img { opacity: 0 !important; visibility: hidden !important; }
body.oks-a11y-links a { text-decoration: underline !important; background: #ff0 !important; color: #000 !important; }

body.oks-align-1 * { text-align: left !important; }
body.oks-align-2 * { text-align: center !important; }
body.oks-align-3 * { text-align: right !important; }

body.oks-a11y-pause * { animation: none !important; transition: none !important; }

body.oks-ls-1 * { letter-spacing: 0.05em !important; }
body.oks-ls-2 * { letter-spacing: 0.10em !important; }
body.oks-ls-3 * { letter-spacing: 0.16em !important; }

/* Pages that declare a dark theme (Bootstrap 5.3's data-bs-theme, which Moodle
   5.3's colour modes use, or data-theme): the default focus blue falls under 3:1
   against a dark background, so the fallback moves to a lighter blue. An explicit
   --oks-focus-color still wins. */
html[data-bs-theme="dark"], html[data-theme="dark"] { --oks-focus-auto: #6ea8fe; }

/* Focus highlight colour is themeable via --oks-focus-color (default #005fcc):
   set it on :root for a dark theme so the highlight stays visible. The
   persistent "all interactive" dashed derives a 45% tint from it; the glow can
   be overridden on its own with --oks-focus-glow. */
body.oks-a11y-focus a:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-focus button:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-focus input,
body.oks-a11y-focus select,
body.oks-a11y-focus textarea {
  outline: 2px dashed color-mix(in srgb, var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) 45%, transparent) !important;
  outline-offset: 2px !important;
}
body.oks-a11y-focus *:focus-visible {
  outline: 3px solid var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 6px var(--oks-focus-glow, color-mix(in srgb, var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) 25%, transparent)) !important;
}

body.oks-a11y-contrast.oks-a11y-focus *:focus,
body.oks-a11y-contrast.oks-a11y-focus *:focus-visible {
  outline-color: #0ff !important;
  box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.3) !important;
}

@media (pointer: fine) {
  body.oks-big-cursor, body.oks-big-cursor a, body.oks-big-cursor button {
    cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 24 24'%3E%3Cpath d='M4 2L4 18L8 14L11 21L14 19.5L11 13L15.5 13Z' stroke='white' stroke-width='4' stroke-linejoin='round' fill='white'/%3E%3Cpath d='M4 2L4 18L8 14L11 21L14 19.5L11 13L15.5 13Z' fill='black'/%3E%3C/svg%3E") 8 4, auto !important;
  }
}

body.oks-a11y-contrast,
body.oks-a11y-contrast *:not(oksigenia-access-panel):not(oksigenia-access-panel *) {
  background-color: #000 !important;
  color: #ff0 !important;
  border-color: #ff0 !important;
  text-shadow: none !important;
  box-shadow: none !important;
}
body.oks-a11y-contrast img { filter: grayscale(100%) contrast(120%) !important; }
body.oks-a11y-contrast a:not(oksigenia-access-panel *) { color: #0ff !important; text-decoration: underline !important; }

/* High-contrast applies background:#000 to every descendant of body to flip
   the page to inverted colours. That selector also catches our own overlays
   (.oks-reading-guide, .oks-overlay-effect), which would then paint a solid
   black band on top of the text and defeat their purpose. Restore the
   overlay-specific values here so they keep working in high-contrast mode. */
body.oks-a11y-contrast .oks-reading-guide {
  background-color: rgba(255, 255, 0, 0.25) !important;
  border-top-color: #ff0 !important;
  border-bottom-color: #ff0 !important;
}
body.oks-a11y-contrast .oks-overlay-effect {
  background-color: transparent !important;
}

.oks-overlay-effect {
  position: fixed; top: 0; left: 0;
  width: 100%; height: 100%;
  pointer-events: none;
  z-index: 999990;
  display: none;
  backdrop-filter: grayscale(100%);
}
.oks-overlay-effect.is-active { display: block; }

.oks-reading-guide {
  position: fixed; left: 0;
  width: 100%; height: 50px;
  background: rgba(255, 255, 0, 0.2);
  border-top: 3px solid red;
  border-bottom: 3px solid red;
  pointer-events: none;
  z-index: 2147483647;
  display: none;
  transform: translateY(-50%);
}
body.oks-a11y-guide .oks-reading-guide { display: block; }

/* Reading mask: dark overlay leaving a horizontal band lit around the cursor.
   --oks-mask-y is updated from JS on mousemove; band is ±90px around it. */
.oks-reading-mask {
  position: fixed; top: 0; left: 0;
  width: 100vw; height: 100vh;
  pointer-events: none;
  z-index: 2147483646;
  background: rgba(0, 0, 0, 0.75);
  display: none;
  clip-path: polygon(
    0 0, 100% 0,
    100% calc(var(--oks-mask-y, 50vh) - 90px),
    0    calc(var(--oks-mask-y, 50vh) - 90px),
    0    calc(var(--oks-mask-y, 50vh) + 90px),
    100% calc(var(--oks-mask-y, 50vh) + 90px),
    100% 100%, 0 100%
  );
}
body.oks-a11y-mask .oks-reading-mask { display: block; }
body.oks-a11y-contrast .oks-reading-mask { background-color: rgba(0, 0, 0, 0.85) !important; }

/* Big targets: bump interactive hit-areas to WCAG 2.5.5 (44×44 minimum).
   Only adjusts padding + min-* — never display, so layouts that rely on
   inline flow or grid placement survive. Exempts our own shadow-DOM host. */
body.oks-a11y-bigtargets a:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-bigtargets button:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-bigtargets [role="button"]:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-bigtargets input[type="checkbox"]:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-bigtargets input[type="radio"]:not(oksigenia-access-panel):not(oksigenia-access-panel *),
body.oks-a11y-bigtargets summary:not(oksigenia-access-panel):not(oksigenia-access-panel *) {
  min-height: 44px !important;
  min-width: 44px !important;
  padding: 8px 12px !important;
  box-sizing: border-box !important;
}
`;

/**
 * Scoped-mode effect CSS (#scope). Emits only the controls that can be confined
 * to a container by selector — the same rules as EFFECT_CSS but anchored to the
 * scope element instead of `body`. The non-scopable effects (colour-blind, which
 * is a `filter` on `<html>`; the full-screen overlays grayscale / reading guide /
 * reading mask; and big cursor) are NOT here — a scoped instance auto-excludes
 * those controls, so they never appear in a per-pane panel.
 *
 * Text size scopes as the container's `font-size`, so it scales `em`/inherited
 * text inside the pane but not `rem` (which is always relative to `<html>` —
 * there is no CSS way to anchor rem to a container). Hosts that want per-pane
 * text scaling size that pane's text in `em`.
 *
 * `s` is a host-provided CSS selector (e.g. `#map-pane`), trusted like the
 * effects-exclude value.
 */
export function scopedEffectCss(s: string): string {
  // When the scope IS the document root (`body`/`html`/`:root`), the global zoom
  // rule `html:has(body.oks-zoom-N)` already scales the page; emitting the scoped
  // font-size too would compound (1.5 × 1.5 = 2.25×). Let the global one handle
  // zoom in that case; everything else still scopes fine.
  const isRoot = s === 'body' || s === 'html' || s === ':root';
  const zoom = isRoot ? '' : `
${s}.oks-zoom-1 { font-size: 110% !important; }
${s}.oks-zoom-2 { font-size: 120% !important; }
${s}.oks-zoom-3 { font-size: 135% !important; }
${s}.oks-zoom-4 { font-size: 150% !important; }
`;
  return `html[data-bs-theme="dark"], html[data-theme="dark"] { --oks-focus-auto: #6ea8fe; }
${zoom}
${s}.oks-lh-1 * { line-height: 1.6 !important; }
${s}.oks-lh-2 * { line-height: 1.9 !important; }
${s}.oks-lh-3 * { line-height: 2.2 !important; }

${s}.oks-a11y-font, ${s}.oks-a11y-font *${NOT_ICON_FONT} { font-family: Arial, sans-serif !important; }

${s}.oks-dyslexia *${NOT_ICON_FONT} {
  font-family: 'Comic Sans MS', 'Verdana', sans-serif !important;
  letter-spacing: 0.05em !important;
  word-spacing: 0.1em !important;
  line-height: 1.6 !important;
}

${s}.oks-a11y-hide img { opacity: 0 !important; visibility: hidden !important; }
${s}.oks-a11y-links a { text-decoration: underline !important; background: #ff0 !important; color: #000 !important; }

${s}.oks-align-1 * { text-align: left !important; }
${s}.oks-align-2 * { text-align: center !important; }
${s}.oks-align-3 * { text-align: right !important; }

${s}.oks-a11y-pause * { animation: none !important; transition: none !important; }

${s}.oks-ls-1 * { letter-spacing: 0.05em !important; }
${s}.oks-ls-2 * { letter-spacing: 0.10em !important; }
${s}.oks-ls-3 * { letter-spacing: 0.16em !important; }

${s}.oks-a11y-focus a,
${s}.oks-a11y-focus button,
${s}.oks-a11y-focus input,
${s}.oks-a11y-focus select,
${s}.oks-a11y-focus textarea {
  outline: 2px dashed color-mix(in srgb, var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) 45%, transparent) !important;
  outline-offset: 2px !important;
}
${s}.oks-a11y-focus *:focus-visible {
  outline: 3px solid var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 6px var(--oks-focus-glow, color-mix(in srgb, var(--oks-focus-color, var(--oks-focus-auto, #005fcc)) 25%, transparent)) !important;
}

${s}.oks-a11y-contrast, ${s}.oks-a11y-contrast * {
  background-color: #000 !important;
  color: #ff0 !important;
  border-color: #ff0 !important;
  text-shadow: none !important;
  box-shadow: none !important;
}
${s}.oks-a11y-contrast img { filter: grayscale(100%) contrast(120%) !important; }
${s}.oks-a11y-contrast a { color: #0ff !important; text-decoration: underline !important; }
${s}.oks-a11y-contrast.oks-a11y-focus *:focus-visible {
  outline-color: #0ff !important;
  box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.3) !important;
}

${s}.oks-a11y-bigtargets a,
${s}.oks-a11y-bigtargets button,
${s}.oks-a11y-bigtargets [role="button"],
${s}.oks-a11y-bigtargets input[type="checkbox"],
${s}.oks-a11y-bigtargets input[type="radio"],
${s}.oks-a11y-bigtargets summary {
  min-height: 44px !important;
  min-width: 44px !important;
  padding: 8px 12px !important;
  box-sizing: border-box !important;
}
`;
}
